// @ts-nocheck
import OnlineOrderHistory from '@components/my-purchases/online-orders/OnlineOrdersHistory';

import PageLayout from '@components/PageLayout';

import { getLabelFallback } from '@utils/utils';

const OnlineOrders = (): JSX.Element => {
    const onlineOrdersBackLabel = getLabelFallback('MYPURCHASES_ONLINE_ORDERS_BACK_CTA_LABEL');
    const onlineOrdersLabel = getLabelFallback('MYPURCHASES_ONLINE_ORDERS_PAGE_TOP_LABEL');

    return (
        <PageLayout
            data_element_id="AccountSummary_History"
            hideMenu
            isOnlineOrders
            labelMenu={onlineOrdersLabel}
            backLabel={onlineOrdersBackLabel}
        >
            <OnlineOrderHistory />
        </PageLayout>
    );
};

export default OnlineOrders;
